module.exports = __webpack_public_path__ + "img/cardcategories.ea5cc380.png";